import React from 'react';
import { Grid, Typography } from '@mui/material';
import { Star, StarHalf, StarBorder } from '@mui/icons-material';
import { StorefrontReviewData } from '../../../api';
import { useLanguage } from '../../../utils/GeneralUtils';

type ReviewCardProps = {
  review: StorefrontReviewData;
};

export const ReviewCard = ({ review }: ReviewCardProps) => {
  const language = useLanguage();

  return (
    <Grid
      container
      flexDirection="column"
      sx={{
        padding: 3,
        borderRadius: 2,
        border: '1px solid #e0e0e0',
        boxShadow: '0 4px 12px rgba(0,0,0,0.15)',
        backgroundColor: 'white',
        height: '100%',
      }}>
      <Grid container mb={2}>
        {[1, 2, 3, 4, 5].map((star) => {
          const filled = review.score >= star;
          const half = !filled && review.score >= star - 0.5;
          const StarIcon = filled ? Star : half ? StarHalf : StarBorder;
          return (
            <StarIcon
              key={star}
              sx={{
                color: filled || half ? '#FFD700' : '#E0E0E0',
                fontSize: 20,
              }}
            />
          );
        })}
      </Grid>
      {review.text?.[language] && (
        <Typography
          variant="body2"
          sx={{
            flex: 1,
            marginBottom: 2,
            lineHeight: 1.6,
          }}
          dangerouslySetInnerHTML={{ __html: review.text[language] || '' }}
        />
      )}
      <Typography variant="subtitle2" sx={{ fontWeight: 600 }}>
        {review.reviewer_name?.[language]}
      </Typography>
    </Grid>
  );
};
